const coverageKeys = {
  ACCIDENTAL_DEATH_LIMIT: 'accidental_death_limit',
  ADDITIONAL_EQUIPMENT: 'additional_equipment',
  BODILY_INJURY_LIMIT: 'bodily_injury_limit',
  COLLISION_DEDUCTIBLE: 'collision_deductible',
  COLLISION_DEDUCTIBLE_WAIVER: 'collision_deductible_waiver',
  COMPREHENSIVE_DEDUCTIBLE: 'comprehensive_deductible',
  EXTRAORDINARY_MEDICAL: 'extraordinary_medical',
  FULL_TORT: 'full_tort',
  FUNERAL_BENEFIT_LIMIT: 'funeral_benefit_limit',
  GAP: 'gap',
  GLASS: 'glass',
  INCOME_LOSS_LIMIT: 'income_loss_limit',
  LOAN_LEASE_PAYOFF: 'loan_lease_payoff',
  LOSS_OF_USE: 'loss_of_use',
  MEDICAL_LIMIT: 'medical_limit',
  NEW_CAR_REPLACEMENT: 'new_car_replacement',
  OEM_PARTS: 'oem_parts',
  PERSONAL_INJURY_PROTECTION_LIMIT: 'personal_injury_protection_limit',
  PET_PASSENGER: 'pet_passenger',
  PROPERTY_DAMAGE_LIMIT: 'property_damage_limit',
  RENTAL_REIMBURSEMENT: 'rental_reimbursement',
  RIDESHARING: 'ridesharing',
  ROADSIDE_ASSISTANCE: 'roadside_assistance',
  SIDE_HUSTLE: 'side_hustle',
  TEMPORARY_RIDE: 'temporary_ride',
  TOWING_ROAD_SERVICES: 'towing_road_services',
  UNDERINSURED_MOTORIST_BODILY_INJURY_LIMIT:
    'underinsured_motorist_bodily_injury_limit',
  UNDERINSURED_MOTORIST_STACKED: 'underinsured_motorist_stacked',
  UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIMIT:
    'underinsured_motorist_property_damage_limit',
  UNINSURED_MOTORIST_BODILY_INJURY_LIMIT:
    'uninsured_motorist_bodily_injury_limit',
  UNINSURED_MOTORIST_STACKED: 'uninsured_motorist_stacked',
  UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIMIT:
    'uninsured_motorist_property_damage_limit',
  UNINSURED_MOTORIST_PROPERTY_DAMAGE_DEDUCTIBLE:
    'uninsured_motorist_property_damage_deductible',
} as const;

export default coverageKeys;
